import { createContext, useState, useEffect } from 'react';
import api from '../utils/api';
import { API_ENDPOINT_V1 } from '../utils/url';
import { useDispatch, useSelector } from 'react-redux';
import GtagEvent from '../utils/gtagEvent';
export const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    const filtered = projects.filter((project) =>
      project.name.includes(searchKeyword)
    );
    setFilteredProjects(filtered);
  }, [searchKeyword, projects]);

  const fetchProjects = async () => {
    if (!user) return;
    try {
      setIsLoaded(false);
      const projectsResponse = await api.get(`${API_ENDPOINT_V1}/projects`);
      setProjects(projectsResponse);
      setFilteredProjects(projectsResponse);
      setSearchKeyword('');
    } catch (error) {
    } finally {
      setIsLoaded(true);
    }
  };

  const deleteProject = async (id, owner, currentUser) => {
    setIsLoaded(false);
    if (owner === currentUser.email || currentUser.role === 'admin') {
      await api.delete(`${API_ENDPOINT_V1}/projects/${id}`);
      GtagEvent('Removed a project', currentUser, id);
    } else {
      await api.get(`${API_ENDPOINT_V1}/projects/${id}/remove-shares`);
      GtagEvent('Removed a shared project', currentUser, id);
    }
    setIsLoaded(true);
    await fetchProjects();
  };

  async function addProject(projectName) {
    let type;
    let text;
    try {
      setIsLoaded(false);
      let res = await api.post(`${API_ENDPOINT_V1}/projects`, {
        name: projectName,
      });
      dispatch({
        type: 'SNACKBAR_PRINT',
        payload: {
          type: 'success',
          text: res.message,
        },
      });
      await fetchProjects();
    } catch (error) {
      dispatch({
        type: 'SNACKBAR_PRINT',
        payload: {
          type: 'error',
          text:
            error.response.data.error ||
            'Oops, something went wrong, try later!',
        },
      });
    } finally {
      setIsLoaded(true);
    }
  }

  const value = {
    isLoaded,
    setIsLoaded,
    fetchProjects,
    projects,
    filteredProjects,
    setProjects,
    deleteProject,
    addProject,
    searchKeyword,
    setSearchKeyword,
  };

  return (
    <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>
  );
};
